import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfiguracoesService } from './configuracoes.service';
import { ConfiguracoesModel } from './configuracoes.model';
import { Global } from '../global';
import { Funcoes } from '../funcoes';
import { LoginService } from '../login/login.service';
import { BasicValidators } from '../shared/basic-validators';

@Component({
  selector: 'app-configuracoes',
  templateUrl: './configuracoes.component.html'
})
export class ConfiguracoesComponent implements OnInit {
  form: FormGroup;
  config: ConfiguracoesModel = new ConfiguracoesModel();

  urlUploadLogoPainel: string;
  urlUploadLogoPdf: string;
  urlUploadLogoEmail: string;
  urlUploadLogoDashboard: string;

  salvando: boolean = false;
  privilegioUsuario = { editar: false, consultar: false };
  mascaraCNPJ = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];

  constructor(
    private fb: FormBuilder,
    private configService: ConfiguracoesService,
    public global: Global,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    this.urlUploadLogoPainel = this.global.dominio_site + '/adm/configuracoes/upload-logo-painel/';
    this.urlUploadLogoPdf = this.global.dominio_site + '/adm/configuracoes/upload-logo-pdf/';
    this.urlUploadLogoEmail = this.global.dominio_site + '/adm/configuracoes/upload-logo-email/';
    this.urlUploadLogoDashboard = this.global.dominio_site + '/adm/configuracoes/upload-logo-dashboard/';

    this.form = this.fb.group({
      id: [null],
      nome_sistema: [''],
      nome_empresa: [''],
      cnpj: ['', [BasicValidators.cnpj]],
      telefone: [''],
      email: [''],
      site: [''],
      endereco: [''],
      numero: [''],
      complemento: [''],
      bairro: [''],
      cidade: [''],
      estado: [''],
      cep: [''],
      logo_painel: [''],
      logo_pdf: [''],
      logo_email: [''],
      logo_dashboard: [''],
      pdf_mi_cor_titulo_header: [''],
      pdf_mi_cor_secao: [''],
      pdf_mi_cor_borda_num: [''],
      pdf_mi_cor_fundo_num: ['']
    });

    this.loginService.getUserInfo().subscribe(data => {
      if (data && data.privilegios) {
        for (let i in data.privilegios) {
          if (data.privilegios[i].acao && data.privilegios[i].acao[0] && data.privilegios[i].acao[0].url === 'configuracoes') {
            this.privilegioUsuario.consultar = data.privilegios[i].consultar;
            this.privilegioUsuario.editar = data.privilegios[i].editar;
          }
        }
      }
      if (data && (data.master || data.adm)) {
        this.privilegioUsuario.consultar = true;
        this.privilegioUsuario.editar = true;
      }
    });
  }

  ngOnInit() {
    this.carregar();
  }

  carregar() {
    this.configService.getConfiguracoes().subscribe(
      (json: any) => {
        if (json && json.Payload) {
          let item = Array.isArray(json.Payload[0])
            ? json.Payload[0][0]
            : (Array.isArray(json.Payload) ? json.Payload[0] : json.Payload);
          if (item) {
            this.config = item;
            this.form.patchValue(this.config);
          }
        }
      },
      error => {
        if (error && error.json) {
          this.func.showErro(error.json());
        }
      }
    );
  }

  salvar() {
    if (!this.form.valid) return;

    this.salvando = true;
    let values = Object.assign({}, this.form.value);

    if (values.logo_painel && (values.logo_painel.includes('fakepath') || values.logo_painel.includes('C:'))) {
      values.logo_painel = (this.config.logo_painel && !this.config.logo_painel.includes('fakepath')) ? this.config.logo_painel : '';
    } else if (!values.logo_painel && this.config.logo_painel) {
      values.logo_painel = this.config.logo_painel;
    }

    if (values.logo_pdf && (values.logo_pdf.includes('fakepath') || values.logo_pdf.includes('C:'))) {
      values.logo_pdf = (this.config.logo_pdf && !this.config.logo_pdf.includes('fakepath')) ? this.config.logo_pdf : '';
    } else if (!values.logo_pdf && this.config.logo_pdf) {
      values.logo_pdf = this.config.logo_pdf;
    }

    if (values.logo_email && (values.logo_email.includes('fakepath') || values.logo_email.includes('C:'))) {
      values.logo_email = (this.config.logo_email && !this.config.logo_email.includes('fakepath')) ? this.config.logo_email : '';
    } else if (!values.logo_email && this.config.logo_email) {
      values.logo_email = this.config.logo_email;
    }

    if (values.logo_dashboard && (values.logo_dashboard.includes('fakepath') || values.logo_dashboard.includes('C:'))) {
      values.logo_dashboard = (this.config.logo_dashboard && !this.config.logo_dashboard.includes('fakepath')) ? this.config.logo_dashboard : '';
    } else if (!values.logo_dashboard && this.config.logo_dashboard) {
      values.logo_dashboard = this.config.logo_dashboard;
    }

    this.configService.salvarConfiguracoes(values, values.id).subscribe(
      (json: any) => {
        this.salvando = false;
        this.func.showSucesso(this.func.traduzir('back.operacaoRealizadaSucesso'));
        this.carregar();
      },
      error => {
        this.salvando = false;
        if (error && error.json) {
          this.func.showErro(error.json());
        }
      }
    );
  }

  uploadLogoPainelComplete(event) {
    this.func.showSucesso(this.func.traduzir('back.operacaoRealizadaSucesso'));
    let data = event;
    if (typeof event === 'string') {
      try { data = JSON.parse(event); } catch (e) {}
    }
    if (data && data.Payload) {
      let item = Array.isArray(data.Payload[0]) ? data.Payload[0][0] : (Array.isArray(data.Payload) ? data.Payload[0] : data.Payload);
      if (item && item.logo_painel) {
        this.config.logo_painel = item.logo_painel;
        if (this.form && this.form.controls['logo_painel']) {
          this.form.controls['logo_painel'].setValue(item.logo_painel);
        }
      }
    }
    this.carregar();
  }

  uploadLogoPdfComplete(event) {
    this.func.showSucesso(this.func.traduzir('back.operacaoRealizadaSucesso'));
    let data = event;
    if (typeof event === 'string') {
      try { data = JSON.parse(event); } catch (e) {}
    }
    if (data && data.Payload) {
      let item = Array.isArray(data.Payload[0]) ? data.Payload[0][0] : (Array.isArray(data.Payload) ? data.Payload[0] : data.Payload);
      if (item && item.logo_pdf) {
        this.config.logo_pdf = item.logo_pdf;
        if (this.form && this.form.controls['logo_pdf']) {
          this.form.controls['logo_pdf'].setValue(item.logo_pdf);
        }
      }
    }
    this.carregar();
  }

  uploadLogoEmailComplete(event) {
    this.func.showSucesso(this.func.traduzir('back.operacaoRealizadaSucesso'));
    let data = event;
    if (typeof event === 'string') {
      try { data = JSON.parse(event); } catch (e) {}
    }
    if (data && data.Payload) {
      let item = Array.isArray(data.Payload[0]) ? data.Payload[0][0] : (Array.isArray(data.Payload) ? data.Payload[0] : data.Payload);
      if (item && item.logo_email) {
        this.config.logo_email = item.logo_email;
        if (this.form && this.form.controls['logo_email']) {
          this.form.controls['logo_email'].setValue(item.logo_email);
        }
      }
    }
    this.carregar();
  }

  uploadLogoDashboardComplete(event) {
    this.func.showSucesso(this.func.traduzir('back.operacaoRealizadaSucesso'));
    let data = event;
    if (typeof event === 'string') {
      try { data = JSON.parse(event); } catch (e) {}
    }
    if (data && data.Payload) {
      let item = Array.isArray(data.Payload[0]) ? data.Payload[0][0] : (Array.isArray(data.Payload) ? data.Payload[0] : data.Payload);
      if (item && item.logo_dashboard) {
        this.config.logo_dashboard = item.logo_dashboard;
        if (this.form && this.form.controls['logo_dashboard']) {
          this.form.controls['logo_dashboard'].setValue(item.logo_dashboard);
        }
      }
    }
    this.carregar();
  }

  getLogoUrl(path: string): string {
    if (!path || path.includes('fakepath') || path.includes('C:')) return '';
    if (path.startsWith('http')) return path;
    if (path.startsWith('/')) return this.global.dominio_site + path;
    return this.global.dominio_site + '/' + path;
  }

  onColorChange(field: string, val: string) {
    if (this.form && this.form.controls[field]) {
      this.form.controls[field].setValue(val, { emitEvent: true });
      this.config[field] = val;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/configuracoes/configuracoes.component.ts